import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/RecoveryEmail.svg'

export const IconRecoveryEmail = IconSVG as IconComponent
